module.exports = __webpack_public_path__ + "static/Lnvasia-a03a71468e5e453c6b4f4361fa61ce77.svg";